const defaultMessageTemplate1 = `Hi {{candidate_first_name}},

I really enjoyed reading your profile and would love to chat to you about what we are up to at {{company_name}}.

If you're interested, we can set up a time to chat about the role in more detail.

Kind regards,
{{sender_first_name}}`

const defaultMessageTemplate2 = `Hello {{candidate_first_name}},

I came across your profile and was impressed by your experience.

At {{company_name}}, we're working on some exciting projects that align well with your skills.

Would you be open to a quick chat about potential opportunities?

Best regards,
{{sender_first_name}}`

const defaultMessageTemplate3 = `Hi {{candidate_first_name}},

Your background caught my attention, and I'd love to tell you more about the work we're doing at {{company_name}}.

Let me know if you'd be interested in learning more about our team and the role.

Cheers,
{{sender_first_name}}`

const defaultMessageTemplate4 = `Dear {{candidate_first_name}},

I'm reaching out from {{company_name}} because your experience matches what we're looking for in our team.

I'd be happy to discuss how your skills could contribute to our mission. Are you available for a quick chat?

Warm regards,
{{sender_first_name}}`

const defaultMessageTemplate5 = `Hi {{candidate_first_name}},

I was reviewing profiles and yours stood out to me.

At {{company_name}}, we're building something special and I think you could be a great addition to our team.

Would you be interested in learning more about what we do?

Best,
{{sender_first_name}}`

const defaultMessageTemplate6 = `Hi {{candidate_first_name}},

I'm reaching out on behalf of {{company_name}}, and I was particularly impressed by your background.

We're currently working on some projects that could really benefit from your expertise.

Would you be interested in learning more about what we're building?

Best regards,
{{sender_first_name}}`

const defaultMessageTemplate7 = `Hello {{candidate_first_name}},

Your experience caught my attention. At {{company_name}}, we're looking for talented individuals like yourself.

I'd love to share more about our vision and see if there might be a great fit for you here.

Warm regards,
{{sender_first_name}}`

const defaultMessageTemplate8 = `Hi {{candidate_first_name}},

I noticed your impressive track record, and I think you could bring valuable insights to our team at {{company_name}}.

Would you be open to a brief conversation about potential opportunities?

Best,
{{sender_first_name}}`

const defaultMessageTemplate9 = `Dear {{candidate_first_name}},

I'm reaching out from {{company_name}} because your experience aligns perfectly with what we're looking for.

I'd love to discuss how your skills could contribute to our growing team. Are you available for a quick chat?

Kind regards,
{{sender_first_name}}`

const defaultMessageTemplate10 = `Hi {{candidate_first_name}},

Your profile caught my attention because of your expertise and your track record.

We're building something special here at {{company_name}}, and I think you could be a great addition to our team.

Would you be interested in learning more?

Best,
{{sender_first_name}}`

const defaultMessageTemplates = [
  defaultMessageTemplate1,
  defaultMessageTemplate2,
  defaultMessageTemplate3,
  defaultMessageTemplate4,
  defaultMessageTemplate5,
  defaultMessageTemplate6,
  defaultMessageTemplate7,
  defaultMessageTemplate8,
  defaultMessageTemplate9,
  defaultMessageTemplate10,
]

export default defaultMessageTemplates
